var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"velodrom-loader",attrs:{"role":"img","aria-label":"Loading Velodrom bike builder"}},[_c('img',{staticClass:"velodrom-loader-mark",attrs:{"src":_vm.logo,"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }